/**
 * Validador de RUT Chileno
 * Basado en: https://gist.github.com/donpandix/f1d638c3a1a908be02d5
 */
export const Fn = {
  // Valida el rut con su cadena "XXXXXXXX-X" o "XX.XXX.XXX-X"
  validaRut: function (rutIn) {
    if (!rutIn) return false;
    
    // Opcional: Limpiar los puntos para que la regex funcione si el usuario escribió "12.345.678-9"
    let rutCompleto = rutIn.replace(/\./g, '');

    if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto))
      return false;

    var tmp = rutCompleto.split('-');
    var digv = tmp[1];
    var rut = tmp[0];
    if (digv === 'K') digv = 'k';
    
    // Comparación usando == en lugar de === porque dv retorna num o string
    return (Fn.dv(rut) == digv); 
  },
  
  dv: function(T) {
    var M = 0, S = 1;
    for (; T; T = Math.floor(T / 10)) {
      S = (S + T % 10 * (9 - M++ % 6)) % 11;
    }
    return S ? S - 1 : 'k';
  },

  esPersonaNatural: function(rutIn) {
    if (!Fn.validaRut(rutIn)) return false;
    const clean = rutIn.replace(/\./g, '').split('-')[0];
    const num = parseInt(clean, 10);
    return num < 50000000;
  },

  esEmpresa: function(rutIn) {
    if (!Fn.validaRut(rutIn)) return false;
    const clean = rutIn.replace(/\./g, '').split('-')[0];
    const num = parseInt(clean, 10);
    return num >= 50000000;
  }
};
